import axios, { type AxiosResponse } from 'axios'

import type { ReleaseNoteVersionResponseSchema } from '@/api/schemas/releaseNotes/releaseNotes'
import { API_ENDPOINTS } from '@/constants'

class ReleaseNotesQueries {
    fetchLatestVersion(): Promise<AxiosResponse<ReleaseNoteVersionResponseSchema>> {
        return axios.get<ReleaseNoteVersionResponseSchema>(API_ENDPOINTS.APP_MANAGEMENT.WHATS_NEW_LATEST)
    }
}

export default new ReleaseNotesQueries()
